import axios from 'axios'

const ContactForm = {
  data () {
    return {
      address: {
        error: '',
        required: true,
        type: 'text',
        value: '',
      },
      city: {
        error: '',
        required: true,
        type: 'text',
        value: '',
      },
      email: {
        error: '',
        required: false,
        type: 'email',
        value: '',
      },
      form: {
        errors: [],
        sending: false,
        submitted: false,
        valid: false
      },
      message: {
        error: '',
        required: false,
        type: 'text',
        value: '',
      },
      name: {
        error: '',
        required: true,
        type: 'text',
        value: '',
      },
      phone: {
        error: '',
        required: true,
        type: 'tel',
        value: '',
      },
      postcode: {
        error: '',
        required: true,
        type: 'number',
        validation: 'postcode',
        value: '',
      },
      termsCheckbox: {
        error: '',
        required: true,
        type: 'checkbox',
        value: false,
      },
      type: {
        value: this.initialType ?? (this.setType()?.value ?? 1)
      }
    }
  },
  props: [
    'endpoint',
    'initialType',
    'pageIndex',
    'types'
  ],
  methods: {
    handleSubmit: function() {
      this.form.errors = []

      this.validate(this.address)
      this.validate(this.city)
      this.validate(this.email)
      this.validate(this.name)
      this.validate(this.phone)
      this.validate(this.postcode)
      this.validate(this.termsCheckbox)

      if (this.form.errors.length === 0) {
        const payload = {
          Type: parseInt(this.type.value),
          Message: this.message.value,
          Customer: {
            Name: this.name.value,
            Email: this.email.value,
            Phone: this.phone.value,
            Address: this.address.value,
            ZipCode: this.postcode.value,
            City: this.city.value
          }
        }

        this.form.sending = true

        axios.post(this.endpoint, payload)
          .then(response => {
            let data = response?.data?.Data?.EventDataLayer
              ? response.data.Data.EventDataLayer
              : null

            // console.log('CONTACT FORM SUCCESS', data)

            if (window.dataLayer && data != null) {
              window.dataLayer.push(data)
            }

            this.form.valid = true
          })
          .catch(error => {
          // console.log('CONTACT FORM ERROR', error)
            this.form.valid = false
          })
          .finally(() => {
            this.form.submitted = true
            this.form.sending = false
          })
      }
    },
    handlePage(direction) {
      this.form.errors = []

      this.validate(this.message)

      if (this.form.errors.length === 0) {
        bus.$emit('form_box_switch_page', direction)
      }
    },
    setType: function() {
      return this.types.find(item => {
        return item.selected
      })
    },
    validate: function(element) {
      this.form.errors.push('error')

      const hasValidValue = this.validateValue(element)

      if (hasValidValue) {
        element.error = ''
        this.form.errors.splice(-1, 1)
      } else {
        if (element.required) {
          if (!!element.value) {
            element.error = 'invalid'
          } else {
            element.error = 'required'
          }
        } else {
          if (!!element.value) {
            element.error = 'invalid'
          } else {
            element.error = ''
            this.form.errors.splice(-1, 1)
          }
        }
      }

    },
    validateValue: function(element) {
      const validateAgainst = element.validation ? element.validation : element.type

      switch (validateAgainst) {
        case 'email':
          const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return emailRegex.test(element.value)
        case 'postcode':
          const postcodeRegex = /^(\d{3})\s?(\d{2})$/
          return postcodeRegex.test(element.value)
        case 'checkbox':
          return element.required
            ? element.value
            : true
        default:
          return element.value.length > 0
      }
    }
  },
}

export default ContactForm
